<template>
    <div>
        <transition name="fade" mode="out-in">
        <router-view name="myclaims" />
        </transition>
      </div>
</template>

<script>

import taskList from '@/components/TaskList.vue'

import { mapActions } from 'vuex'

export default {
  name: 'myClaims',
  components: {
    taskList
  },
  data: () => {
    return {

    }
  },
  mounted () {

  },
  computed: {

  },
  methods: {

  }
}
</script>
